import noop from 'lodash/noop'
import React, { createContext, FC, useCallback, useState } from 'react'

export enum PaymentProviders {
  AdyenCreditCard = 'AdyenCreditCard',
  AdyenBankSelector = 'AdyenBankSelector',
  BraintreeCreditCard = 'BraintreeCreditCard',
  ByJuno = 'ByJuno',
}

interface PaymentProviderBusProps {
  allData: Record<PaymentProviders, unknown>
  busData: unknown | null
  setBusData: (unknown) => void
}
export const PaymentProviderBusContext = createContext<(provider: PaymentProviders) => PaymentProviderBusProps>(() => ({
  allData: {} as Record<PaymentProviders, unknown>,
  busData: null,
  setBusData: noop,
}))

export const PaymentProviderBusProvider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [data, setData] = useState<Record<PaymentProviders, unknown>>({} as Record<PaymentProviders, unknown>)

  const setBusData = (provider: PaymentProviders) => (newData: unknown) => {
    setData({
      ...data,
      [provider]: newData,
    })
  }

  const value = useCallback((provider: PaymentProviders) => ({
    allData: data,
    busData: data[provider],
    setBusData: setBusData(provider),
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [data])
  return (
    <PaymentProviderBusContext.Provider value={value}>
      {children}
    </PaymentProviderBusContext.Provider>
  )
}
